import React from 'react';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { SEASON_START_LANDING_NAME } from 'landings/season-start';
import { State } from 'store/types';
import { SeasonStartRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

registerWidget<State, Record<string, string>>(`${__NAME__}/${SEASON_START_LANDING_NAME}`, state => {
  const router = getGlobalRouter();
  const store = initWidgetData(state);

  return remoteProps => <SeasonStartRemote router={router} store={store} {...remoteProps} />;
});

